import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Button, Card, Flex, FormListFieldData } from "antd";
import { useWatch } from "antd/es/form/Form";
import { observer } from "mobx-react-lite";
import React, { Fragment, useMemo } from "react";
import { PathContextProvider } from "../context/PathContext";
import { ConfigComponentMap, SaveConfig } from "../types/Config";
import { DefaultConfigInput } from "./DefaultConfigInput";

type Props = {
  field: FormListFieldData;
  length: number;
  index: number;
  onRemove: () => void;
  moveUp: () => void;
  moveDown: () => void;
  namePath: Array<string | number>;
};

export const FieldConfigListItem = observer((props: Props) => {
  const t = useTranslation();
  // const name = useWatch<SaveConfig, string>((values) => {
  //   if (!values.config) return undefined;
  //   if (!values.config[props.field.name]) return undefined;
  //   return values.config[props.field.name].name;
  // });
  //[...props.namePath, "name"]
  const obj = useWatch<SaveConfig, SaveConfig>((values) => values);
  const name = obj?.config[props.index]?.name;
  const path = useMemo(() => [props.field.name], [props.field.name]);
  const ConfigComponent = name
    ? (ConfigComponentMap[name] ?? Fragment)
    : Fragment;

  return (
    <Card
      title={
        <Flex justify="space-between" align="center">
          {t("maintenance:ticket.creation.config.form.field.label." + name)}
          <Flex gap="small" align="center" justify="flex-end">
            <Button onClick={props.onRemove} danger>
              <Icon icon="fa:trash" />
            </Button>
            {props.field.name !== 0 ? (
              <Button onClick={props.moveUp}>
                <Icon icon="fa:arrow-up" />
              </Button>
            ) : null}

            {props.field.name < props.length - 1 ? (
              <Button onClick={props.moveDown}>
                <Icon icon="fa:arrow-down" />
              </Button>
            ) : null}
          </Flex>
        </Flex>
      }
    >
      <PathContextProvider value={path}>
        <DefaultConfigInput />
        <ConfigComponent />
      </PathContextProvider>
    </Card>
  );
});
